import type { FaireProductEntity } from "../../entity_types/product";

export const p_6vyjsakrwf: FaireProductEntity = {
  token: "p_6vyjsakrwf",
  type: "product",
  name: "Gold and Silver Heart Spring Gate Clasp for JewelryCLG163",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/64c024ea61e7d18a582a555c1d2c3331624fff73eb094dc594bcb8f09d718f1f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08c7509e6e0d97adc00742446ca3db2b3564dfb6706495497ae3b58d4ddee6fa.jpeg",
    "https://cdn.faire.com/fastly/eaae4d7b2bc7d919a8e2262bdc65a09c4c95fa274092d71ad7ef9cefcddfe595.jpeg",
    "https://cdn.faire.com/fastly/f656ea461efda6ecbcde1059183afc74f6835eaa923ae4edf740c067dea94d01.jpeg",
    "https://cdn.faire.com/fastly/dc2ac0ed3f39da914031a9e019745bba0626a625c421be726f8ba5c473fb5aaa.jpeg",
    "https://cdn.faire.com/fastly/905748c9f7ebbc044a4bf9040c9638c19af3a17ae96fdb5bd7f631af9e9d3864.jpeg",
    "https://cdn.faire.com/fastly/93ef236e0aa05c0457603109d06b38f48a43b620d4135f1206cafa37e2532eca.jpeg",
  ],
  priceDollars: 7.44,
  description:
    "Gold Or Silver Heart Shape Spring Push In Gate Clasp For Jewelry Making.CLG163-CLS163\nListing is for one single piece.\n\n14K Gold Rhodium And Black Plating over brass.\n\nMeasurements :16.0mm x 15.7mm\nThickness:3.1mm\nAll Measurements Are Approximate\nNickel, Lead and Cadmium Free\nIf you have any question please feel free to message us.\n\nShips From Los Angeles\nBulk discount is available at drop down menu",
  tags: [],
  msrpDollars: 14.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:59.028Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
